import React, { useState, Suspense, lazy } from 'react';
import { useHistory } from 'react-router-dom';
import userHaveRolePermission from '../../../../helpers/userHaveRolePermission';
import { PAGE_URLS } from '../../../../helpers/endpoints';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import 'styles/custom/progressPaymentStatusTracking.less';

const CourierProgressPaymentStatusTracking = lazy(() => import('./Courier'));
const StoreProgressPaymentStatusTracking = lazy(() => import('./Store'));

const ProgressPaymentStatusTracking = ({ route }) => {
  const history = useHistory();
  const { isViewEnabled, isInvoiceApproveButton } = userHaveRolePermission(route?.name);
  if (!isViewEnabled) {
    history.push(`${PAGE_URLS.AUTH}${PAGE_URLS.CONTROL}`);
  }
  const { t } = useTranslation();
  const [activeTabKey, setActiveTabKey] = useState('STORE');

  return (
    <Suspense fallback={<></>}>
      <Tabs type="line" activeKey={activeTabKey} onChange={(key) => setActiveTabKey(key)}>
        <Tabs.TabPane tab={t('storeProgressPaymentTracking')} key="STORE">
          {activeTabKey === 'STORE' && <StoreProgressPaymentStatusTracking isViewEnabled={isViewEnabled}/>}
        </Tabs.TabPane>
        <Tabs.TabPane tab={t('courierProgressPaymentTracking')} key="COURIER">
          {activeTabKey === 'COURIER' && <CourierProgressPaymentStatusTracking isViewEnabled={isViewEnabled} isInvoiceApproveButton={isInvoiceApproveButton}/>}
        </Tabs.TabPane>
      </Tabs>
    </Suspense>
  );
};

export default ProgressPaymentStatusTracking;
